import React from "react";
import Navbar from "../components/Shared/Navbar";
import Footer from "../components/Shared/Footer";
import UserProfileNavbar from "../components/Shared/UserProfileNavbar";

const UserProfileLayout = ({ children }) => {
  return (
    <div>
      {/* 1440 */}
      <Navbar maxWidth={1200} />

      <div className="mx-auto max-w-[1340px] lg:px-2 md:px-4 sm:px-4 py-4 flex gap-2 items-start">
        <div className="lg:w-2/12 md:w-3/12 sm:w-0 lg:block md:block sm:hidden">
          <UserProfileNavbar />
        </div>
        <div className="lg:w-10/12 md:w-9/12 sm:w-full">{children}</div>
      </div>
      {/* 1440 */}
      <Footer maxWidth={1200} />
    </div>
  );
};

export default UserProfileLayout;
